// extracted by mini-css-extract-plugin
export var sbShowMain = "blog-post-module--sb-show-main--3Zy6R";
export var title = "blog-post-module--title--7alpc";
export var downloadBtn = "blog-post-module--downloadBtn--38iNv";